import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { Autocomplete } from "@material-ui/lab";
import Add from "@material-ui/icons/Add";

import CustomPopperUI from "./CustomPopperUI";
import { getTasksListing } from "../../data/services/API";
import { TASK_OPTIONS } from "../../utils/constants";
import Button from "../Button";
import { Delete } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  switch: {
    "& .custom_popper_content": {
      width: "500px",
    },
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  switchCaseTab: {
    padding: "4px",
  },
}));

const ForkPathsPopperUI = (props) => {
  const classes = useStyles();
  const {
    setShowTasksPopper,
    task,
    updateTaskListWithTask,
    deleteForkPathFromTask,
    closeTasksPopper,
    tasks,
  } = props;
  const [taskArrayForSelectListing, setTaskArrayForSelectListing] = useState(
    TASK_OPTIONS
  );

  const [addNewCase, setAddNewCase] = useState(false);
  const [selectedTaskFromList, setSelectedTaskFromList] = useState(null);
  const [selectedCase, setSelectedCase] = useState(null);
  const [switchCaseName, setSwitchCaseName] = useState("");

  const [deleteSwitchCasePosition, setdeleteSwitchCasePosition] = useState(
    null
  );
  const [modalHeight, getModalHeight] = useState(null);
  const [modalWidth, getModalWidth] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(true);

  var anchorEl = props.anchorEl;
  var elementName = "#" + anchorEl + ".addbtn";

  var element = document.querySelector(elementName);
  var modalElement = document.querySelector(".custom_popper_content");

  const switchCases = useMemo(() => {
    if (task) {
      let cases = [];
      const { forkTasks } = task;
      if (forkTasks) {
        for (let i = 1; i <= forkTasks.length; i++) {
          cases.push(`Fork Path ${i}`);
        }
      }

      return cases;
    }
  }, [task]);

  const CaseUi = useMemo(() => {
    if (addNewCase) {
      return (
        <Grid item xs={12}>
          <TextField
            id={`input-parameter-custom`}
            autoComplete="off"
            variant="outlined"
            label="Path"
            fullWidth
            value={switchCaseName} // Set the value
            onChange={(e) => setSwitchCaseName(e.target.value)} // Set the onChange
          />
        </Grid>
      );
    } else {
      return (
        <Grid item xs={12}>
          <Autocomplete
            id="custom-add-switch-case"
            options={switchCases}
            disabled={switchCases.length === 1}
            clearOnBlur={false}
            freeSolo
            getOptionLabel={(option) => option.task ?? option}
            value={
              switchCases.length === 1
                ? "No Paths To Delete"
                : selectedCase
                ? selectedCase
                : ""
            }
            // inputValue={ipAutoVal}
            // onChange={(e, newVal) => setSelectedCase(newVal)}
            onChange={(e, newVal) => changeSelectedCase(newVal)}
            disableClearable
            // onInputChange={(e, newVal) => handleAutoChange(e, newVal)}
            renderInput={(params) => (
              <TextField
                {...params}
                autoComplete="off"
                label="Fork Paths"
                variant="outlined"
                ref={params.InputProps.ref}
                InputProps={{
                  ...params.InputParams,
                  endAdornment: selectedCase && (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          changeSelectedCase("");
                        }}
                        size="small">
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      );
    }
  }, [addNewCase, switchCases, switchCaseName, selectedCase]);

  const handleAddNewCaseCheck = (e, val) => setAddNewCase(val);

  const handleSelectTask = (e, val) => {

    setSelectedTaskFromList(val);
  };

  const deleteForkPath = () => {

    const match = selectedCase.match(/\d+/);
    var index = parseInt(match[0]) - 1;
    deleteForkPathFromTask(task, index);
  };

  useEffect(() => {
    (async () => {
      try {
        const resp = await getTasksListing();
        const { data } = resp;
        setTaskArrayForSelectListing(data);
      } catch (error) {
        if (error.response) console.log(error.response);
      }
    })();

    return () => {};
  }, []);

  useEffect(() => {
    if (element) {
      const rect = element.getBoundingClientRect();
      setdeleteSwitchCasePosition(rect);
    }
    if (modalElement) {
      const modalHeight = modalElement.clientHeight;
      const modalWidth = modalElement.clientWidth;
      getModalHeight(modalHeight);
      getModalWidth(modalWidth);
    }
  }, [element, modalElement]);

  useEffect(() => {

    setBtnDisabled(!selectedCase);
  }, [selectedCase]);

  const changeSelectedCase = (value) => {

    setSelectedCase(value);
  };
  return (
    <CustomPopperUI
      className={classes.switch}
      deleteSwitchCasePosition={deleteSwitchCasePosition}
      modalHeight={modalHeight}
      modalWidth={modalWidth}>
      <Box className="custom_popper_header">
        <Grid
          container
          spacing={2}
          alignItems="flex-end"
          justifyContent="center">
          <Grid item xs={10}>
            <Box className="custom_popper_header__title">Delete Fork Path</Box>
          </Grid>
          <Grid item xs={2} className="custom_popper_close">
            {/* Close button */}
            <IconButton
              color="primary"
              className={classes.iconButton}
              aria-label="close"
              onClick={() => closeTasksPopper()} // Function to close the popper
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Box className={`custom_popper_task-tab ${classes.switchCaseTab}`}>
        <Grid
          container
          spacing={2}
          alignItems="flex-end"
          justifyContent="center">
          {CaseUi}

          {switchCases.length !== 1 && (
            <Grid item xs={12}>
              <Button
                // disabled={btnDisabled}
                disabled={selectedCase ? selectedCase === "" : true}
                style={{ marginTop: "8px" }}
                onClick={deleteForkPath}>
                <Delete /> Delete
              </Button>
            </Grid>
          )}
        </Grid>
      </Box>
    </CustomPopperUI>
  );
};

export default ForkPathsPopperUI;
